export default __webpack_public_path__ + "static/media/6 Functional Strength Videos.709f9cb0.webp";